// Inject sticky ATC styles
const style = document.createElement("style");
style.innerHTML = `
  .sticky-add-to-cart {
    display: none;
    padding: 15px 64px;
    z-index: 9999;
    transition: transform 0.3s ease;
  }
  .sticky-add-to-cart.desktop {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    border-bottom: 1px solid rgba(20, 43, 111, 0.2);
    background: #fff;
    box-shadow: 0 -1px 6px rgba(0, 0, 0, 0.1);
  }
  .sticky-add-to-cart.mobile {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    justify-content: center;
  }
  .sticky-add-to-cart-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1472px;
    max-width: 100%;
    margin: auto;
  }
  .sticky-add-to-cart .product-title {
    font-weight: bold;
    font-size: 26px;
    flex: 1;
    color: #142b6f;
  }
  .sticky-add-to-cart .order-btn {
    background: #000;
    color: #fff;
    padding: 15px 50px;
    border: none;
    border-radius: 106px;
    font-weight: bold;
    font-size: 19px;
    cursor: pointer;
    background-color: #142b6f;
    transition: .3s ease opacity;
  }
  .sticky-add-to-cart .order-btn:hover {
    opacity: 0.5;
  }
  .sticky-add-to-cart.mobile .order-btn {
    width: 100%;
  }
  .sticky-add-to-cart.mobile {
    padding: 15px 30px;
  }
`;
document.head.appendChild(style);

document.addEventListener("DOMContentLoaded", () => {
  const target =
    document.querySelector('[data-instant-action-type="add-to-cart"]') ||
    document.querySelector('[data-instant-action-type="redirect-to-cart"]') ||
    document.querySelector('.combo-btn');
  const variantPicker =
    document.querySelector(".instant-custom-variant-picker") ||
    document.querySelector(".instant-selling-plan-selector");

  if (!target || !variantPicker) return;

  const stickyBar = document.createElement("div");
  stickyBar.className = "sticky-add-to-cart";
  document.body.appendChild(stickyBar);

  const productTitleInput = document.getElementById(
    "product-name-for-sticky-atc"
  );
  const productTitle = productTitleInput?.value || "Product";

  stickyBar.innerHTML = `
    <div class="sticky-add-to-cart-inner"><span class="product-title">${productTitle}</span>
    <button class="order-btn">Order Now +</button></div>
  `;

  const orderBtn = stickyBar.querySelector(".order-btn");
  orderBtn?.addEventListener("click", () => {
    const header = document.getElementById("iw61qYOfmQo4ixtlC");
    const headerHeight = header?.offsetHeight || 0;

    const scrollTarget =
      document.querySelector(".instant-custom-variant-picker") ||
      document.querySelector(".instant-selling-plan-selector");

    if (scrollTarget) {
      const elementTop =
        scrollTarget.getBoundingClientRect().top + window.scrollY;
      const offsetTop = elementTop - headerHeight - 10;

      window.scrollTo({
        top: offsetTop,
        behavior: "smooth",
      });
    }
  });

  const isMobile = () => window.innerWidth <= 768;

  const updateSticky = () => {
    const rect = target?.getBoundingClientRect();
    if (!rect) return;

    if (rect.bottom < 0) {
      stickyBar.style.display = "block";
      stickyBar.classList.toggle("desktop", !isMobile());
      stickyBar.classList.toggle("mobile", isMobile());
      stickyBar
        .querySelector(".product-title")
        ?.style.setProperty("display", isMobile() ? "none" : "inline-block");
    } else {
      stickyBar.style.display = "none";
    }
  };

  window.addEventListener("scroll", updateSticky);
  window.addEventListener("resize", updateSticky);
  updateSticky();
});

// --- Slider functionality ---
const carousel = document.querySelector(
  ".cart-recommended-products-inner-carousel"
);
const items = document.querySelectorAll(".cart-recommended-product-carousel");

let itemWidth = 0;
if (items.length > 0) {
  const itemStyle = getComputedStyle(items[0]);
  itemWidth = items[0].offsetWidth + parseInt(itemStyle.marginRight || 0);
}

let currentOffset = 0;
let isDown = false;
let startX;
let scrollStart;

function snapToNearest() {
  if (!carousel || itemWidth === 0) return;
  const slideIndex = Math.round(-currentOffset / itemWidth);
  currentOffset = -slideIndex * itemWidth;
  carousel.style.transform = `translateX(${currentOffset}px)`;
}

if (carousel && items.length > 0) {
  carousel.addEventListener("mousedown", (e) => {
    isDown = true;
    carousel.classList.add("dragging");
    startX = e.pageX;
    scrollStart = currentOffset;
  });

  carousel.addEventListener("mouseleave", () => {
    isDown = false;
    carousel.classList.remove("dragging");
  });

  carousel.addEventListener("mouseup", () => {
    isDown = false;
    carousel.classList.remove("dragging");
    snapToNearest();
  });

  carousel.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    const dx = e.pageX - startX;
    carousel.style.transform = `translateX(${scrollStart + dx}px)`;
    currentOffset = scrollStart + dx;
  });

  carousel.addEventListener(
    "touchstart",
    (e) => {
      isDown = true;
      startX = e.touches[0].clientX;
      scrollStart = currentOffset;
    },
    { passive: true }
  );

  carousel.addEventListener(
    "touchmove",
    (e) => {
      if (!isDown) return;
      const dx = e.touches[0].clientX - startX;
      carousel.style.transform = `translateX(${scrollStart + dx}px)`;
      currentOffset = scrollStart + dx;
    },
    { passive: true }
  );

  carousel.addEventListener("touchend", () => {
    isDown = false;
    snapToNearest();
  });
}

document
  .querySelector(".cart-recommended-products-top-icon-right")
  ?.addEventListener("click", (e) => {
    e.preventDefault();
    const maxOffset = -(items.length - 1) * itemWidth;
    currentOffset -= itemWidth;
    if (currentOffset < maxOffset) currentOffset = maxOffset;
    carousel?.style.setProperty("transform", `translateX(${currentOffset}px)`);
  });

document
  .querySelector(".cart-recommended-products-top-icon-left")
  ?.addEventListener("click", (e) => {
    e.preventDefault();
    currentOffset += itemWidth;
    if (currentOffset > 0) currentOffset = 0;
    carousel?.style.setProperty("transform", `translateX(${currentOffset}px)`);
  });

document.addEventListener("instant:add-to-cart", () => {
  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      updates: {},
      sections: ["cart-drawer", "cart-icon-bubble"],
    }),
  })
    .then((res) => res.json())
    .then((cart) => {
      document.querySelector("cart-drawer")?.renderContents(cart);
      document
        .querySelector("cart-drawer.drawer")
        ?.classList.remove("is-empty");
    });
});

// --- Delegated ATC for cart recommended ---
document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("click", function (event) {
    const button = event.target.closest(".cart-recommended-product-atc");
    if (!button) return;

    event.preventDefault();
    const productId = button.getAttribute("data-product-id");
    if (!productId) return;

    const productElement = button.closest(".cart-recommended-product");
    const loadingSpinner = productElement?.querySelector(".loading__spinner");

    if (loadingSpinner) loadingSpinner.classList.remove("hidden");

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: productId, quantity: 1 }),
    })
      .then((res) =>
        res.ok ? res.json() : res.json().then((err) => Promise.reject(err))
      )
      .then(() => fetch(`${routes.cart_url}?section_id=cart-drawer`))
      .then((res) => res.text())
      .then((htmlText) => {
        const html = new DOMParser().parseFromString(htmlText, "text/html");
        const selectors = [
          ".drawer__header",
          ".free-shipping-progress-block",
          ".cart__contents",
          ".cart-drawer__footer",
        ];
        selectors.forEach((selector) => {
          const newEl = html.querySelector(selector);
          const oldEl = document.querySelector(selector);
          if (newEl && oldEl) oldEl.replaceWith(newEl);
        });

        if (productElement) productElement.style.display = "none";
      })
      .catch(console.error)
      .finally(() => loadingSpinner?.classList.add("hidden"));
  });
});

// --- Subscription Conversion ---
document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("click", function (event) {
    const button = event.target.closest(".convert-to-subscription");
    if (!button) return;

    event.preventDefault();
    const variantId = button.getAttribute("data-variant-id");
    const sellingPlanId = button.getAttribute("data-selling_plan_id");
    if (!sellingPlanId || !variantId) return;

    button.textContent = "Saving...";

    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity: 1,
        selling_plan: sellingPlanId,
      }),
    })
      .then((res) => res.json())
      .then(() => fetch(`${routes.cart_url}?section_id=cart-drawer`))
      .then((res) => res.text())
      .then((htmlText) => {
        const html = new DOMParser().parseFromString(htmlText, "text/html");
        const selectors = [
          ".drawer__header",
          ".free-shipping-progress-block",
          ".cart__contents",
          ".cart-drawer__footer",
        ];
        selectors.forEach((selector) => {
          const newEl = html.querySelector(selector);
          const oldEl = document.querySelector(selector);
          if (newEl && oldEl) oldEl.replaceWith(newEl);
        });
      })
      .catch((err) => {
        console.error(err);
        button.textContent = "Save 10%";
      });
  });
});

// --- Subscription dropdown ---
document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("change", function (event) {
    const select = event.target.closest("select");
    if (!select) return;

    const wrapper = select.closest(".select-subscription");
    const variantId = wrapper?.getAttribute("data-variant-id");
    const cartItem = select.closest(".cart-item");
    const quantity =
      parseInt(cartItem?.querySelector(".quantity__input")?.value) || 1;
    if (!variantId || quantity <= 0) return;

    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity,
        selling_plan: select.value,
      }),
    })
      .then((res) => res.json())
      .then(() => fetch(`${routes.cart_url}?section_id=cart-drawer`))
      .then((res) => res.text())
      .then((htmlText) => {
        const html = new DOMParser().parseFromString(htmlText, "text/html");
        const selectors = [
          ".drawer__header",
          ".free-shipping-progress-block",
          ".cart__contents",
          ".cart-drawer__footer",
        ];
        selectors.forEach((selector) => {
          const newEl = html.querySelector(selector);
          const oldEl = document.querySelector(selector);
          if (newEl && oldEl) oldEl.replaceWith(newEl);
        });
      })
      .catch(console.error);
  });
});

// --- Cart trigger ---
document.querySelector(".cart-trigger")?.addEventListener("click", () => {
  const cartDrawer = document.querySelector("cart-drawer");
  if (cartDrawer) {
    cartDrawer.classList.toggle("active");
    document.body.classList.add("overflow-hidden");
  }
});

// --- Header scroll hide ---
document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".shopify-section-group-header-group");
  if (!header) return;

  let lastScroll = window.scrollY;
  header.style.transition = "opacity 0.3s ease";

  window.addEventListener("scroll", () => {
    const current = window.scrollY;
    if (current > lastScroll && current > 0) {
      header.style.opacity = "0";
      header.style.pointerEvents = "none";
    } else {
      header.style.opacity = "1";
      header.style.pointerEvents = "auto";
    }
    lastScroll = current <= 0 ? 0 : current;
  });
});

// --- Popup fade on homepage ---
document.addEventListener("DOMContentLoaded", () => {
  const isHome = window.location.href === "https://clearly.eu/";
  const popup = document.querySelector(".language-popup");
  const body = document.body;
  const trigger = document.querySelector(".language-popup-trigger");
  const closeBtn = document.querySelector(".close-language-popup");

  const fadeIn = (el, dur = 400) => {
    if (!el) return;
    el.style.opacity = 0;
    el.style.display = "block";
    el.style.transition = `opacity ${dur}ms ease`;
    requestAnimationFrame(() => (el.style.opacity = 1));
  };

  const fadeOut = (el, dur = 400) => {
    if (!el) return;
    el.style.transition = `opacity ${dur}ms ease`;
    el.style.opacity = 0;
    setTimeout(() => (el.style.display = "none"), dur);
  };

  if (isHome && popup) {
    setTimeout(() => {
      fadeIn(popup);
      body.classList.add("language-popup-open");
    }, 1500);
  }

  trigger?.addEventListener("click", (e) => {
    e.preventDefault();
    fadeIn(popup);
    body.classList.add("language-popup-open");
  });

  closeBtn?.addEventListener("click", (e) => {
    e.preventDefault();
    fadeOut(popup);
    body.classList.remove("language-popup-open");
  });

  setTimeout(() => {
    document.querySelectorAll(".language-popup-language a").forEach((link) => {
      link.setAttribute("target", "_self");
    });
  }, 1500);
});

document.addEventListener("DOMContentLoaded", function () {
  const comboBoxes = document.querySelectorAll(".combo-box");

  if (!comboBoxes.length) return; // Exit if no combo-box found

  comboBoxes.forEach((comboBox) => {
    if (!comboBox) return;

    const children = Array.from(comboBox.children || []);
    if (!children.length) return;

    // If no child has 'active-combo', assign it to the first child
    if (!children.some((child) => child.classList?.contains("active-combo"))) {
      children[1]?.classList?.add("active-combo");
    }

    // Add click listeners to each first-level child
    children.forEach((child) => {
      if (!child) return;
      child.addEventListener("click", () => {
        children.forEach((c) => c?.classList?.remove("active-combo"));
        child.classList?.add("active-combo");
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const comboBtn = document.querySelector(".combo-btn");
  if (!comboBtn) return;

  comboBtn.addEventListener("click", async function (e) {
    e.preventDefault();

    // Add loading state
    comboBtn.classList.add("instant-loading");
    comboBtn.style.cursor = "wait";
    comboBtn.setAttribute("disabled", "disabled");

    const activeOption = document.querySelector(
      '.instant-custom-variant-picker[data-instant-state="active"]'
    );
    const notCoffeeVariant = activeOption?.getAttribute(
      "data-instant-option-value"
    );
    var not_coffee_id;
    if (notCoffeeVariant == "Original") {
      not_coffee_id = 47145860530506;
    } else {
      not_coffee_id = 47145860563274;
    }
    const comboBox = document.querySelector(".combo-box");
    if (!comboBox) return;

    const firstChild = comboBox.children[0];
    const secondChild = comboBox.children[1];
    var items, discountCode;
    if (firstChild?.classList.contains("active-combo")) {
      items = [
        {
          id: not_coffee_id,
          quantity: 1,
          selling_plan: 691789594954,
        },
      ];
      discountCode = 'DEAL';
    } else if (secondChild?.classList.contains("active-combo")) {
      items = [
        {
          id: not_coffee_id,
          quantity: 1,
          selling_plan: 691789594954,
        },
        {
          id: 48982341845322,
          quantity: 1,
          selling_plan: 691789594954,
        },
      ];
      discountCode = 'COMBODEAL';
    }

    try {
      // Clear the cart
      await fetch("/cart/clear.js", { method: "POST" });

      // Add each item with selling plan
      for (const item of items) {
        await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: item.id,
            quantity: item.quantity,
            selling_plan: item.selling_plan,
          }),
        });
      }

      // Go to checkout
       window.location.href = '/checkout?discount='+discountCode;
    } catch (error) {
      console.error("Add-to-cart failed:", error);

      // Optionally rollback UI if failed
      comboBtn.classList.remove("instant-loading");
      comboBtn.style.cursor = "";
      comboBtn.removeAttribute("disabled");
    }
  });
});
